import React from 'react';
import { Box, SxProps, Theme } from '@mui/material';

interface TableHeaderProps {
  col: number;
  value: string;
  x: number;
  y: number;
  width: number;
  height: number;
  isFirstColumn?: boolean;
  sx?: SxProps<Theme>;
}

const BORDER_RADIUS = '4px';

const headerCellStyles = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  fontSize: '12px',
  lineHeight: '16px',
  fontWeight: 700,
  color: '#F6F8F9',
  backgroundColor: '#2F736E',
};

const firstHeaderStyles = {
  borderTopLeftRadius: BORDER_RADIUS,
  borderBottomLeftRadius: BORDER_RADIUS,
};

const TableHeader: React.FC<TableHeaderProps> = ({
  col,
  value,
  x,
  y,
  width,
  height,
  isFirstColumn = false,
  sx = {},
}) => {
  return (
    <Box
      id={`header-${col}`}
      sx={{
        position: 'absolute',
        left: x,
        top: y,
        width,
        height,
        ...headerCellStyles,
        ...(isFirstColumn && firstHeaderStyles),
        ...sx,
      }}
    >
      {value}
    </Box>
  );
};

export default TableHeader;
